import { BoxProps } from "@chakra-ui/react";
import { IKeyFigure } from "src/api/server/extended-search";
import { MemoizedRangeSliderWithInputs } from "src/components/common/range-slider/range-slider-with-inputs";
import { IKeyFigureValue } from "src/components/pages/search/components/types";
import { ISearch } from "src/components/pages/search/search.types";
import { handleKeyFigureChange } from "src/components/pages/search/store/actions";
import { useSearchStore } from "src/components/pages/search/store/search-store";

interface IRangeSliderListProps extends ISearch, BoxProps {
    keyFiguresData: ReadonlyArray<IKeyFigure>;
}

export const RangeSliderList = ({ keyFiguresData, onSearch }: IRangeSliderListProps) => {
    const { keyFigures: storeKeyFigures } = useSearchStore();

    const handleChange = (keyFigure: IKeyFigureValue) => {
        handleKeyFigureChange({
            newKeyFigureValue: keyFigure,
            onSearch,
            keyFiguresData,
        });
    };

    return (
        <>
            {keyFiguresData.map(({ steps, id, isUnitOfMeasurementPercentage, showPositiveLeadingSign, label, isPopular }) => {
                const min = steps[0];
                const max = steps[steps.length - 1];

                const selectedKeyFigure = storeKeyFigures.find(storeKeyFigure => storeKeyFigure.id === id);
                const selectedValues = selectedKeyFigure ? [selectedKeyFigure.min, selectedKeyFigure.max] : [min, max];

                return (
                    <MemoizedRangeSliderWithInputs
                        key={id}
                        label={label}
                        selectedValues={selectedValues as [number?, number?]}
                        steps={steps}
                        onChange={(minMax: number[]) => handleChange({ id, min: minMax[0], max: minMax[1], isPopular })}
                        showMarks
                        shouldShowPercentageLabel={isUnitOfMeasurementPercentage}
                        showPositiveLeadingSign={showPositiveLeadingSign}
                    />
                );
            })}
        </>
    );
};
